export var BackgroundEffectGroups;
(function (BackgroundEffectGroups) {
    BackgroundEffectGroups["noEffectsBlur"] = "noEffectsBlur";
    BackgroundEffectGroups["simple"] = "simple";
    BackgroundEffectGroups["office"] = "office";
    BackgroundEffectGroups["medical"] = "medical";
    BackgroundEffectGroups["outdoor"] = "outdoor";
    BackgroundEffectGroups["fun"] = "fun";
})(BackgroundEffectGroups || (BackgroundEffectGroups = {}));
